(function () {
  var SELECTOR = '[data-scroll-fill-text]';
  var WORD_SELECTOR = '.scroll-fill-word';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var instances = [];
  var ticking = false;

  function wrapWords(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var textNodes = [];
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.trim() === '') continue;
      textNodes.push(node);
    }

    textNodes.forEach(function (textNode) {
      var parts = textNode.nodeValue.split(/(\s+)/);
      var fragment = document.createDocumentFragment();

      parts.forEach(function (part) {
        if (part === '') return;
        if (/^\s+$/.test(part)) {
          fragment.appendChild(document.createTextNode(part));
          return;
        }
        var span = document.createElement('span');
        span.className = 'scroll-fill-word';
        span.textContent = part;
        fragment.appendChild(span);
      });

      textNode.parentNode.replaceChild(fragment, textNode);
    });
  }

  function buildInstance(el) {
    if (el.dataset.scrollFillReady) return;
    el.dataset.scrollFillReady = 'true';

    el.classList.add('scroll-fill-text');
    wrapWords(el);

    var instance = {
      el: el,
      words: el.querySelectorAll(WORD_SELECTOR),
      progress: 0,
      target: 0
    };
    instances.push(instance);
    update(instance, true);
  }

  function computeTarget(el) {
    if (reduceMotion.matches) return 1;
    var rect = el.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    var start = viewportHeight * 0.85;
    var end = viewportHeight * 0.3;
    var progress = (start - rect.top) / (start - end);
    return Math.min(1, Math.max(0, progress));
  }

  function update(instance, immediate) {
    instance.target = computeTarget(instance.el);
    if (immediate || reduceMotion.matches) {
      instance.progress = instance.target;
    } else {
      instance.progress += (instance.target - instance.progress) * 0.2;
      if (Math.abs(instance.target - instance.progress) < 0.001) {
        instance.progress = instance.target;
      }
    }

    var total = instance.words.length;
    var filledCount = Math.round(instance.progress * total);

    instance.words.forEach(function (word, index) {
      var shouldFill = index < filledCount;
      if (shouldFill !== word.classList.contains('is-filled')) {
        word.classList.toggle('is-filled', shouldFill);
      }
    });
  }

  function loop() {
    instances = instances.filter(function (instance) {
      return instance.el.isConnected;
    });

    var settled = true;
    instances.forEach(function (instance) {
      update(instance, false);
      if (Math.abs(instance.target - instance.progress) > 0.001) settled = false;
    });

    if (!settled) {
      requestAnimationFrame(loop);
    } else {
      ticking = false;
    }
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(loop);
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(buildInstance);
    requestUpdate();
  }

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);

  init();
})();
